// extracted by mini-css-extract-plugin
export var brand = "_2h-9";
export var compact = "_2h-6";
export var extraSmall = "_2h-7";
export var icon = "_2h-0";
export var large = "_2h-4";
export var light = "_2h-1";
export var medium = "_2h-5";
export var outline = "_2h-b";
export var primaryDark = "_2h-a";
export var primaryLight = "_2h-8";
export var primaryModern = "_2h-c";
export var success = "_2h-2";
export var successSolid = "_2h-3";